import React, { useContext, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  TextField,
  Grid,
  Box,
  Tab,
  Tabs,
  Fab,
  MenuItem,
  Snackbar,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Radio
} from "@mui/material";
import { useSubscriptionState } from "../context/SubscriptionContext";
import { serverTimestamp } from "firebase/firestore";
import MuiAlert from "@mui/material/Alert";

import Swal from 'sweetalert2';
import Status from "./Status";
import { Forms } from "../components/Forms";
import Notes from "../components/Notes";

import { SaveCloseDialog } from "../components/SaveCloseDialog";
import { Save, Close } from "@mui/icons-material";
import ClearIcon from '@mui/icons-material/Clear';

import { doc, getDoc, setDoc, where, query, collection, getDocs, writeBatch } from "firebase/firestore";
import { db } from "config/config";
import { Context } from "context/Wrapper";
import InfiniteScrollSelect from "components/shared/InfiniteScrollSelect";
import { Projects } from "./Projects";
import { useFetchCollectionDocs } from "apis/dataSnapshots";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pl: 0, pr: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export const BuildingDetail = (props) => {
  const context = useContext(Context);

  const { groupId, isPro, userId } = context?.state?.userProfile || {};
  const user = context?.state?.userProfile || {},
    { showAllDataFlag } = context?.state || {};

  const { buildingId } = useParams();
  const location = useLocation()

  const currentSubscription = useSubscriptionState();


  const navigate = useNavigate();

  const [buildingDetail, setBuildingDetail] = useState();

  const [ownerDetails, setOwnerDetails] = React.useState(null);


  useEffect(() => {
    async function getBuildings() {
      const buildingRef = doc(db, "buildings", buildingId);
      const initialBuildingDetail = await getDoc(buildingRef);
      setBuildingDetail(initialBuildingDetail.data());
    }
    getBuildings();

  }, [buildingId]);

  const [isDirty, setIsDirty] = React.useState(false);

  const [tab, setTab] = React.useState(location.state?.FromJobDetailsReferencesBuilding ? 1 : 0);

  const [open, setOpen] = React.useState(false);

  const [dialogOpen, setDialogOpen] = React.useState(false);

  const [failureOpen, setOpenFailure] = React.useState(false);
  const [duplicateOpen, setduplicateOpen] = React.useState(false);
  const [SubmitLoader, setSubmitLoader] = React.useState(false);


  const openSuccess = () => {
    setOpen(true);
  };

  const openFailure = () => {
    setOpenFailure(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleFailureClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenFailure(false);
  };

  const handleduplicateOpen = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setduplicateOpen(false);
  };

  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
  };

  // const handleChange = (e) => {
  //   let currentBuildingDetail = buildingDetail;
  //   currentBuildingDetail[e.target.name] = e.target.value;
  //   setIsDirty(true);
  //   setBuildingDetail({ ...currentBuildingDetail });
  // };


  const handleChange = (e) => {
    let currentBuildingDetail = { ...buildingDetail };

    if (e.target.type === "checkbox") {
      currentBuildingDetail[e.target.name] = e.target.checked;
    } else {
      currentBuildingDetail[e.target.name] = e.target.value;
    }

    setIsDirty(true);
    setBuildingDetail({ ...currentBuildingDetail });
  };





  const handleChangeNotes = (notes) => {
    let currentBuildingDetail = buildingDetail;
    setBuildingDetail({ ...currentBuildingDetail, notes: notes });
  };


  const onSubmit = async () => {
    setSubmitLoader(true);
    const fullAddress = [
      `${buildingDetail.houseNumber || ""} ${buildingDetail.streetName || ""}`,
      buildingDetail.city,
      buildingDetail.state,
      buildingDetail.ZIP,
    ]
      .filter(Boolean)
      .join(", ");

    let ownerString = "";
    if (buildingDetail.owner) {
      const ownerSnap = await getDoc(doc(db, "contacts", buildingDetail.owner));
      ownerString = ownerSnap.exists()
        ? ownerSnap.data().businessName
        : "";
      const ownerString_lc = ownerSnap.data().businessName_lc

    }
    const normalizedCustomerReference = buildingDetail.customerReference.trim().toLowerCase();
    const thisBuilding = doc(db, "buildings", buildingId);
    const currentTimestamp = Date.now();

    try {
      const q = query(collection(db, "buildings"), where("groupId", "==", groupId));
      const querySnapshot = await getDocs(q);
      const isDuplicate = querySnapshot.docs.some(doc => {
        const docData = doc.data();
        const docCustomerReference = docData.customerReference ? docData.customerReference.trim().toLowerCase() : '';
        return doc.id !== buildingId && docCustomerReference === normalizedCustomerReference;
      });

      if (!isDuplicate) {
        await setDoc(thisBuilding, {
          ...buildingDetail,
          ownerString,
          dateCreated: buildingDetail.dateCreated || serverTimestamp(),
          dateUpdated: currentTimestamp, // Changed to epoch
          ownerString_lc: ownerString.toLowerCase(),
          fullAddress,
          fullAddress_lc: fullAddress.toLowerCase(),

          customerReference_lc: buildingDetail.customerReference.trim().toLowerCase(),
          customerReference: buildingDetail.customerReference.trim(),
        }, { merge: true });

        const lcName = buildingDetail.customerReference.trim().toLowerCase();
        const rawAddr = `${buildingDetail.houseNumber || ""} ${buildingDetail.streetName || ""}`.trim();
        const lcAddress = rawAddr.toLowerCase();

        // after setDoc(buildingRef,…)
        const jobsQ = query(
          collection(db, "projects"),
          where("building", "==", buildingId)
        );
        const jobsSnap = await getDocs(jobsQ);
        const batch = writeBatch(db);

        jobsSnap.forEach(jobDoc => {
          batch.update(jobDoc.ref, {
            buildingString_lc: lcName,
            buildingAddress_lc: lcAddress,
          });
        });

        await batch.commit();


        setIsDirty(false);
        openSuccess();
        return true; // Indicate success
      } else {
        setduplicateOpen(true);
        return false; // Indicate duplicate
      }
    } catch (error) {
      console.error("Error updating document:", error);
      openFailure();
      return false; // Indicate failure
    } finally {
      setSubmitLoader(false);
    }
  };

  const saveAndClose = async () => {
    const isSuccess = await onSubmit();

    if (isSuccess) {
      navigate("/buildings", { state: { feedback: { message: 'Building saved successfully!', severity: 'success' } } });
    } else {
      setDialogOpen(false);
    }
  };


  const discardAndClose = () => {
    navigate("/buildings");
  };

  const handleCloseBuilding = () => {
    if (isDirty && !props.isInactive) {
      setDialogOpen(true);
      return;
    }
    navigate("/buildings");
  };

  React.useEffect(() => {
    if (buildingDetail && buildingDetail.owner) {
      const fetchOwnerDetails = async () => {
        const ownerRef = doc(db, "contacts", buildingDetail.owner);
        const initialOwnerDetail = await getDoc(ownerRef);
        const owner = initialOwnerDetail.data();
        setOwnerDetails(owner);
      };
      fetchOwnerDetails();
    }
  }, [buildingDetail]);

  if (!buildingDetail) return null;

  const hasRequiredFields = () => {
    return (
      buildingDetail.customerReference &&
      buildingDetail.houseNumber &&
      buildingDetail.streetName
    );
  };



  const handleChangeDetails = async (e) => {
    const { name, value } = e.target;
    if (isDirty && !props.isInactive) {
      const result = await Swal.fire({
        title: 'You have unsaved changes!',
        text: "Do you want to save your changes or discard them?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: 'Discard',
      });

      if (result.isConfirmed) {
        const isSuccess = await onSubmit();
        if (isSuccess) {
          navigate(`/buildings/details/${value}`);
          window.location.reload();
        }
      } else {
        navigate(`/buildings/details/${value}`);
        window.location.reload();
      }
    } else {
      navigate(`/buildings/details/${value}`);
      window.location.reload();
    }
  };



  return (
    <>



      <Grid container spacing={2} sx={{ marginBottom: "-55px", justifyContent: "flex-end" }}>
        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            disableClear={true}
            collectionName="buildings"
            label="customerReference"
            onChange={handleChangeDetails}
            value={buildingDetail?.customerReference}
            name="customerReference"
            inputLabel="Switch to another Building"
          />
        </Grid>
      </Grid>





      <Typography
        sx={{
          textTransform: "uppercase",
          /*    backgroundColor: "#f89d08",
          padding: "1rem", */
        }}
        align="left"
        variant="h4"
      >
        {buildingDetail.customerReference}
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider", paddingLeft: 0 }}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
        >
          <Tab label="Details" />
          <Tab label="Jobs" />
          <Tab label="DOB status" />
          <Tab label="Notes" />
          <Tab label="Forms" />

        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <Grid container spacing={2}>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Name"
              variant="outlined"
              name="customerReference"
              value={buildingDetail.customerReference}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label={"Borough"}
              name="borough"
              select
              onChange={handleChange}
              value={buildingDetail.borough || ""}
              fullWidth
              InputProps={{
                endAdornment: buildingDetail.borough ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleChange({ target: { name: 'borough', value: '' } })}
                      style={{ marginRight: '10px' }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
            >
              <MenuItem value={"Brooklyn"}>Brooklyn</MenuItem>
              <MenuItem value={"Manhattan"}>Manhattan</MenuItem>
              <MenuItem value={"Bronx"}>Bronx</MenuItem>
              <MenuItem value={"Queens"}>Queens</MenuItem>
              <MenuItem value={"Staten Island"}>Staten Island</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <InfiniteScrollSelect
              collectionName="contacts"
              label="fullName"
              onChange={handleChange}
              value={buildingDetail.owner}
              name="owner"
              inputLabel="Owner"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="BIN"
              variant="outlined"
              name="BIN"
              value={buildingDetail.BIN}
              onChange={handleChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

        </Grid>



        <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
          Address Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="House number"
              variant="outlined"
              name="houseNumber"
              value={buildingDetail.houseNumber}
              onChange={handleChange}
              fullWidth

            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Street name"
              variant="outlined"
              name="streetName"
              value={buildingDetail.streetName}
              onChange={handleChange}
              fullWidth

            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Special place name"
              variant="outlined"
              name="specialPlaceName"
              value={buildingDetail.specialPlaceName}
              onChange={handleChange}
              fullWidth

            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="City"
              variant="outlined"
              name="city"
              value={buildingDetail.city}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="State"
              variant="outlined"
              name="state"
              value={buildingDetail.state}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="ZIP"
              variant="outlined"
              name="ZIP"
              value={buildingDetail.ZIP}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

        </Grid>


        <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
          More Address Details
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Block"
              variant="outlined"
              name="block"
              value={buildingDetail.block}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Lot"
              variant="outlined"
              name="lot"
              value={buildingDetail.lot}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="CB No."
              variant="outlined"
              name="cb"
              value={buildingDetail.cb}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Zoning District"
              variant="outlined"
              name="zoningDistrict"
              value={buildingDetail.zoningDistrict}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Special District"
              variant="outlined"
              name="specialDistrict"
              value={buildingDetail.specialDistrict}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Map Number"
              variant="outlined"
              name="mapNumber"
              value={buildingDetail.mapNumber}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Overlays"
              variant="outlined"
              name="overlays"
              value={buildingDetail.overlays}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
        </Grid>


        <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
          Building Characteristics
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Height"
              variant="outlined"
              name="heightExisting"
              value={buildingDetail.heightExisting}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Stories"
              variant="outlined"
              name="storiesExisting"
              value={buildingDetail.storiesExisting}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Units"
              variant="outlined"
              name="unitsExisting"
              value={buildingDetail.unitsExisting}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Street Frontage"
              variant="outlined"
              name="streetFrontage"
              value={buildingDetail.streetFrontage}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Floor Area"
              variant="outlined"
              name="totalFloorArea"
              value={buildingDetail.totalFloorArea}
              onChange={handleChange}
              fullWidth
            />
          </Grid>


        </Grid>


        <Grid container spacing={2} marginTop={"11px"}>
          {[
            { label: "Landmark", name: "landmark" },
            { label: "Hazmat Site", name: "hazmatSite" },
            { label: "Adult Establishment", name: "adultEstablishment" },
            { label: "SRO", name: "sro" },
            { label: "Street Private", name: "streetPrivate" },
            { label: "Public", name: "public" },
            { label: "123 Family", name: "oneTwoThreeFamily" },
            { label: "Mixed Use", name: "mixedUse" },
            { label: "Other Type", name: "otherType" },
            { label: "Tidal Wetland", name: "tidalWetland" },
            { label: "Urban Renewable", name: "urbanRenewable" },
            { label: "Fire District", name: "fireDistrict" },
            { label: "Flood Hazard", name: "floodHazard" },
            { label: "Unmapped Street", name: "unmappedStreet" }
          ].map((it) => (
            <Grid item xs={12} md={6} lg={4} key={it.name}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={buildingDetail[it.name] || false}
                    onChange={handleChange}
                    name={it.name}
                    sx={{ padding: 0 }}
                  />
                }
                label={it.label}
                sx={{
                  margin: 0,
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </Grid>
          ))}


        </Grid>


        <Grid container spacing={2} marginTop={"11px"}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Structural Occupancy Category"
              variant="outlined"
              name="structuralOccupancyCategory"
              value={buildingDetail.structuralOccupancyCategory}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              select
              label="Construction Classification"
              variant="outlined"
              name="constructionClassification"
              value={buildingDetail.constructionClassification || ""}
              onChange={handleChange}
              fullWidth
              InputProps={{
                endAdornment: buildingDetail.constructionClassification ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleChange({ target: { name: 'constructionClassification', value: '' } })}
                      style={{ marginRight: '10px' }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
            >
              {[
                "1", "1-A", "1-B", "1-C", "1-D", "1-E",
                "2", "2-A", "2-B", "2-C", "2-D", "2-E",
                "3", "3-A", "3-B", "4", "4-HT", "5", "5-A", "5-B", "6"
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>


          <Grid item xs={12} md={6} lg={4}>
            <TextField
              select
              label="Occupancy Classification"
              variant="outlined"
              name="occupancyClassification"
              value={buildingDetail.occupancyClassification || ""}
              onChange={handleChange}
              fullWidth
              InputProps={{
                endAdornment: buildingDetail.occupancyClassification ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleChange({ target: { name: 'occupancyClassification', value: '' } })}
                      style={{ marginRight: '10px' }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ) : null
              }}
            >
              {[
                "A", "A-1", "A-2", "A-3", "A-4", "A-5",
                "B", "B-1", "B-2", "C", "COM", "D-1", "D-2",
                "E", "F-1", "F-1A", "F-1B", "F-2", "F-3", "F-4",
                "G", "H-1", "H-2", "H-3", "H-4", "H-5", "I-1", "I-2", "I-3", "I-4",
                "J-1", "J-2", "J-3", "K", "M", "PUB", "R-1", "R-2", "R-3", "RES",
                "S-1", "S-2", "U"
              ].map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Multiple Dwelling Class"
              variant="outlined"
              name="multipleDwellingClass"
              value={buildingDetail.multipleDwellingClass}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

        </Grid>


        <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
          Fire Protection Equipment
        </Typography>
        <Grid container spacing={2}>
          {[
            { label: "Fire Alarm", name: "fireAlarm" },
            { label: "Sprinkler", name: "sprinkler" },
            { label: "Fire Suppression", name: "fireSuppression" },
            { label: "Stand Pipe", name: "standPipe" },
          ].map((it) => (
            <Grid item xs={12} md={6} lg={4} key={it.name}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={buildingDetail[it.name] || false}
                    onChange={handleChange}
                    name={it.name}
                    sx={{ padding: 0 }}
                  />
                }
                label={it.label}
                sx={{
                  margin: 0,
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </Grid>
          ))}

        </Grid>


        <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
          Primary Structural System
        </Typography>
        <Grid container spacing={2}>
          {[
            { label: "Masonry", name: "masonry" },
            { label: "Concrete (CIP)", name: "concreteCIP" },
            { label: "Concrete (Precast)", name: "concretePrecast" },
            { label: "Wood", name: "wood" },
            { label: "Steel (Structural)", name: "steelStructural" },
            { label: "Steel (Cold-Formed)", name: "steelColdFormed" },
            { label: "Steel (Encased in Concrete)", name: "steelEncasedInConcrete" },
          ].map((it) => (
            <Grid item xs={12} md={6} lg={4} key={it.name}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={buildingDetail[it.name] || false}
                    onChange={handleChange}
                    name={it.name}
                    sx={{ padding: 0 }}
                  />
                }
                label={it.label}
                sx={{
                  margin: 0,
                  fontSize: "0.875rem",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </Grid>
          ))}

        </Grid>

        <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
          Open Spaces
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Plaza"
              variant="outlined"
              name="plaza"
              value={buildingDetail.plaza}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Parking Area"
              variant="outlined"
              name="parkingArea"
              value={buildingDetail.parkingArea}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Arcade"
              variant="outlined"
              name="arcade"
              value={buildingDetail.arcade}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Parking Spaces"
              variant="outlined"
              name="parkingSpaces"
              value={buildingDetail.parkingSpaces}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Loading Area"
              variant="outlined"
              name="loadingArea"
              value={buildingDetail.loadingArea}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Loading Berths"
              variant="outlined"
              name="loadingBerths"
              value={buildingDetail.loadingBerths}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

        </Grid>





        <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
          Code Requirements
        </Typography>

        <Grid container spacing={2} alignItems="center">

          <Grid item xs={12} md={6} lg={4}>
            <Typography variant="h6" sx={{}}>
              Building was originally erected pursuant to which Building Code:
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <Grid container spacing={2}>
              {[
                { label: "2008", name: "2008" },
                { label: "1968", name: "1968" },
                { label: "Prior to 1968", name: "priorTo1968" },
              ].map((it) => (
                <Grid item xs={12} sm={6} md={4} key={it.name}>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={buildingDetail.pursuantBuildingCode === it.name}
                        onChange={handleChange}
                        value={it.name}
                        name="pursuantBuildingCode"
                        sx={{ padding: 0 }}
                      />
                    }
                    label={it.label}
                    sx={{
                      margin: 0,
                      fontSize: "0.875rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Typography variant="h6" sx={{}}>
              The earliest code with which this building or any part of it is required:
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <Grid container spacing={2}>
              {[
                { label: "2008", name: "2008" },
                { label: "1968", name: "1968" },
                { label: "Prior to 1968", name: "priorTo1968" },
              ].map((it) => (
                <Grid item xs={12} sm={6} md={4} key={it.name}>
                  <FormControlLabel
                    control={
                      <Radio
                        checked={buildingDetail.earlyCodeRequired === it.name}
                        onChange={handleChange}
                        value={it.name}
                        name="earlyCodeRequired"
                        sx={{ padding: 0 }}
                      />
                    }
                    label={it.label}
                    sx={{
                      margin: 0,
                      fontSize: "0.875rem",
                      display: "flex",
                      alignItems: "center",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>








        </Grid>












        <Box
          sx={{
            position: "fixed",
            bottom: "1rem",
            right: "1rem",
            "& > :not(style)": { m: 1 },
          }}
        >
          {!props.isInactive && (
            <Fab
              color="primary"
              aria-label="add"
              variant="extended"
              onClick={onSubmit}
              disabled={SubmitLoader || (!isDirty && !hasRequiredFields()) || props.isInactive}
            >
              <Save sx={{ mr: 1 }} />
              Save
            </Fab>
          )}

          <Fab
            color="secondary"
            aria-label="add"
            variant="extended"
            onClick={handleCloseBuilding}
          >
            <Close sx={{ mr: 1 }} />
            Close
          </Fab>

        </Box>

        <SaveCloseDialog
          open={dialogOpen}
          saveAndClose={saveAndClose}
          discardAndClose={discardAndClose}
          setDialogOpen={setDialogOpen}
          isInactive={props.isInactive}
        />
      </TabPanel>

      <TabPanel value={tab} index={1}>
        <Projects isInactive={currentSubscription.isInactive} fromBuildingReferencesJobDetails={{ buildingId, fromBuildingReferencesJob: true }} />
      </TabPanel>

      <TabPanel value={tab} index={2}>
        {!props.isInactive ? (
          <div style={{ height: "calc(100vh - 230px)" }}>
            <Status currentBuilding={{ ...buildingDetail }} />
          </div>
        ) : (
          <div style={{ height: "calc(100vh - 230px)" }}>
            This feature is available with an active subscription.
          </div>
        )}
      </TabPanel>


      <TabPanel value={tab} index={3}>
        <Notes
          notes={buildingDetail.notes}
          handleChangeNotes={handleChangeNotes}
          onSubmit={onSubmit}
          isInactive={props.isInactive}
        />
      </TabPanel>

      <TabPanel value={tab} index={4} style={{ marginBottom: "160px" }}>
        <Forms
          // showLabelBuildingForms={true}
          allData={showAllDataFlag}
          showToggleFromBuilding={true}
          isPro={isPro}
          buildingId={buildingId}
          buildingDetails={buildingDetail}
          ownerDetails={ownerDetails}
          userId={userId}
          db={db}
          groupId={groupId}
          isInactive={props.isInactive}
        />
      </TabPanel>

      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Building saved successfully!
        </Alert>
      </Snackbar>
      <Snackbar
        open={failureOpen}
        autoHideDuration={2000}
        onClose={handleFailureClose}
      >
        <Alert
          onClose={handleFailureClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          Something went wrong!
        </Alert>
      </Snackbar>

      <Snackbar
        open={duplicateOpen}
        autoHideDuration={2000}
        onClose={handleduplicateOpen}
      >
        <Alert
          onClose={handleduplicateOpen}
          severity="error"
          sx={{ width: "100%" }}
        >
          Building name already exists!
        </Alert>
      </Snackbar>
    </>
  );
};
